<template>
  <div>
    <keep-alive>
      <router-view v-if="keep_alive" :title="title"></router-view>
    </keep-alive>
    <router-view v-if="!keep_alive" :title="title"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setDocumentTitle } from '../assets/js/util.js'
export default {
  name: 'enterprise',
  props: {
    title: {},
    transition: {}
  },
  computed: {
    ...mapGetters([
      'enterprise_id'
    ]),
    keep_alive () {
      return this.$route.meta.keep_alive
    }
  },
  methods: {

  },
  created () {
    var _self = this
    var _id = _self.enterprise_id + ''
    var str = ''
    if (_id === '199') {
      str = '小欧出行'
    } else if (_id === '398') {
      str = '奇瑞包车'
    } else if (_id === '498') {
      str = '美光半导体智能用车'
    }
    if (str) {
      setDocumentTitle(str)
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// Enterprise.vue?becdac44